if (!customElements.get('twt-product-bf')) {
  customElements.define('twt-product-bf', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe?.();
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const section = this.closest('product-info');
        if (!section || String(data.sectionId) !== section.dataset.section) return;
        const source = data.html.querySelector(`twt-product-bf[data-product-id="${this.dataset.productId}"] [data-bf-saving]`);
        const target = this.querySelector('[data-bf-saving]');
        if (!source || !target) return;
        target.textContent = source.textContent;
        target.hidden = source.hidden;
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
